module.exports = __webpack_public_path__ + "static/media/occlusion-culling.3a073d20.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/occlusion-culling.jpg
 ** module id = 439
 ** module chunks = 0
 **/